export default "__VITE_ASSET__CAlFYZ8I__"